class SalonReviewModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[data-salon-review-open]');
    this.closeButtons = this.querySelectorAll('[data-salon-review-close]');

    this.openButton?.addEventListener('click', this.open);
    this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
    this.dialog?.addEventListener('click', this.closeOnBackdrop);
  }

  disconnectedCallback() {
    this.openButton?.removeEventListener('click', this.open);
    this.closeButtons.forEach((button) => button.removeEventListener('click', this.close));
    this.dialog?.removeEventListener('click', this.closeOnBackdrop);
  }

  open = () => {
    if (!this.dialog || this.dialog.open) return;
    this.dialog.showModal();
  };

  close = () => {
    this.dialog?.close();
  };

  closeOnBackdrop = (event) => {
    if (event.target === this.dialog) this.close();
  };
}

if (!customElements.get('salon-review-modal')) {
  customElements.define('salon-review-modal', SalonReviewModal);
}
